import React from 'react';
import BTechPrivacy from './BTech';
import KaafiPayPrivacy from './KaafiPay';
import { API_URL } from '../../constants/api';

// Import the specific privacy policy components

const PrivacyPolicy = () => {
  const hostname = API_URL;

  if (hostname.includes('bulshotech')) {
    return <BTechPrivacy />;
  } else if (hostname.includes('kaafipay')) {
    return <KaafiPayPrivacy />;
  } else {
    return <div>No matching privacy policy found for this domain.</div>;
  }
};

export default PrivacyPolicy;
